<template>
  <div style="height: 100%; overflow: auto;">
    <div class="v-data-table-off-overflow" v-if="isLoaded">
      <v-data-table
        dense
        :items="table.items"
        :headers="table.headers"
        disable-pagination
        hide-default-footer
        fixed-header
      />

    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OperatorCampaignStatiscticByDays',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      isLoaded: false,
      table: {
        items: [],
        headers: [
          {text: 'ФИО', value: 'fio'},
          {text: 'Дата', value: 'date'},
          {text: 'Кампания', value: 'campaign'},
          {text: 'Табельное время, общее', value: 'employments_time'},
          {text: 'Мин. На Кампании', value: 'outbound_total_duration_in_min'},
        ],
      },
    }
  },

  computed: {
    ...mapGetters({}),
  },

  watch: {},

  methods: {
    ...mapActions({
      loadOperatorCampaignStatiscticByDaysWidget: 'dashboard/loadOperatorCampaignStatiscticByDaysWidget',
    }),

    async loadData() {
      this.isLoaded = false
      this.table.items = await this.loadOperatorCampaignStatiscticByDaysWidget(this.widget.params)
      this.isLoaded = true
    },
  },
  
  mounted() {
    this.loadData()
  },
}
</script>


<style scoped lang="scss">
.name-cell {
  display: grid;
  align-items: center;
  padding-left:0.2rem;
  padding-right:0.2rem;

  &.name {
    min-width: 120px;
    width: 100%;
  }

  .sliced-name {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>